import React from 'react'
import {Col, Row} from "antd";

const Tabbar = ({
    items=[],
    disabledItems=[],
    activeItem,
    onSelect,
    ...props
})=>{
    return(
        <Row className={' container-md'}>
            {
                items.map(item=><Col flex={`${100/items.length}%`} className={`border padding-sm 
                ${disabledItems.includes(item)?'white30':'pointer'}  
                ${activeItem==item?'primary-bg':'highlight-hover'}
                `}
                onClick={()=>{
                    if(disabledItems.includes(item))
                        return;

                    (typeof onSelect =='function') && onSelect(item)
                }}
                >
                    <Row justify={'center'}>
                        {item}
                    </Row>
                </Col>)
            }
        </Row>
    )
}

export default Tabbar